export enum AnalyticsDataPrefix {
  Amplitude = 'amp',
}

export interface AnalyticsAdapter {
  addVendor: () => void;
  grantConsent: () => void;
  revokeConsent: () => void;
  initialise: (id: string, options?: Record<string, unknown>) => void;
  pageView?: (pageTitle?: string) => void;
  trackEvent?: (data: Record<string, unknown>) => void;
  verifyVendor: () => boolean;
}

export interface AnalyticsSettings {
  facebookIds: string[];
  uiVersion: string;
}

export interface AdapterOptions {
  debug: boolean;
  logger: (message: string) => void;
}
